module.exports = ['$http', function ($http) {
    'use strict';

    $http.get('/get_content_blocks/').success(function(data) {
        angular.extend(StringsSvc, data);
    });

    var StringsSvc = {};
    return StringsSvc;
}];